/**
 * Course Intervention Reducers
 */
import {
    COURSEINTERVENTION_ACTION,
    FETCH_COURSEINTERVENTION,
    ADD_COURSEINTERVENTION,
    GET_COURSEINTERVENTION,
    EDIT_COURSEINTERVENTION,
    DELETE_COURSEINTERVENTION
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    courseinterventionlist:[],
    particularcourseintervention:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case COURSEINTERVENTION_ACTION:
            return { ...state, loading: true };
 
        case FETCH_COURSEINTERVENTION:
            return { ...state, loading: false, courseinterventionlist: action.payload };  
            
        case ADD_COURSEINTERVENTION:
            return { ...state, loading: false };    

        case GET_COURSEINTERVENTION:
            return { ...state, loading: false, particularcourseintervention: action.payload };  
            
        case EDIT_COURSEINTERVENTION:
            return { ...state, loading: false }; 
            
        case DELETE_COURSEINTERVENTION:
            return { ...state, loading: false };     
        
         default: return { ...state };
     }
 }